var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState, useRef } from 'react';
import Tab from './Tab';
import { useComponentVisible } from '../_hooks';
import { map, isValid } from './../_utils';
import { TabEventType } from './TabEventType';
import './Tabs.css';
var buildTabId = function (id) { return "tab-" + id; };
var Tabs = function (props) {
    var _a = props.dropdown, dropdown = _a === void 0 ? true : _a, _b = props.dropdownText, dropdownText = _b === void 0 ? 'More...' : _b, _c = props.selectedTab, selectedTab = _c === void 0 ? 0 : _c, onTabSelect = props.onTabSelect, children = props.children, className = props.className;
    var _d = useState([]), tabs = _d[0], setTabs = _d[1];
    var _e = useState([]), visibleTabs = _e[0], setVisibleTabs = _e[1];
    var _f = useState([]), dropdownTabs = _f[0], setDropdownTabs = _f[1];
    var _g = useState(buildTabId(0)), selectedTabId = _g[0], setSelectedTabId = _g[1];
    var _h = useState([]), tabWidths = _h[0], setTabWidths = _h[1];
    var _j = useState(undefined), navSize = _j[0], setNavSize = _j[1];
    var nav = useRef({});
    var _k = useComponentVisible(false), parentRef = _k.parentRef, toggleRef = _k.toggleRef, isVisible = _k.isVisible;
    isValid(Tabs.name, Tab.name, children);
    useEffect(function () {
        var _a, _b;
        if (children) {
            var allTabs = (_a = map(children, function (child, index) {
                var _a = child.props, title = _a.title, href = _a.href, disabled = _a.disabled, children = _a.children;
                return {
                    id: buildTabId(index),
                    title: title,
                    href: href != null ? href : null,
                    disabled: disabled != null ? disabled : false,
                    content: children
                };
            })) !== null && _a !== void 0 ? _a : [];
            var tabWidths_1 = (_b = allTabs === null || allTabs === void 0 ? void 0 : allTabs.map(function (t) { return getTabWith(t.title); })) !== null && _b !== void 0 ? _b : [];
            setTabs(allTabs);
            setTabWidths(tabWidths_1);
            handleDropdown(allTabs, tabWidths_1);
        }
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, [children]);
    useEffect(function () {
        if (selectedTab !== undefined)
            setSelectedTabId(buildTabId(selectedTab));
    }, [selectedTab]);
    useEffect(function () {
        if (tabs == null || tabs.length <= 0)
            return;
        handleDropdown(tabs, tabWidths);
    }, [navSize, dropdown]);
    var handleDropdown = function (tabs, tabWidths) {
        if (dropdown)
            updateDropdown(tabs, tabWidths);
        else {
            setVisibleTabs(tabs);
            setDropdownTabs([]);
        }
    };
    var handleResize = function () { return setNavSize(nav.current.offsetWidth); };
    var getTabContent = function () {
        var selectedTab = tabs.find(function (t) { return t.id === selectedTabId; });
        return selectedTab != null ? selectedTab.content : null;
    };
    var handleSelectedTabChanged = function (type, nativeEvent) {
        var tabId = undefined;
        if (type === TabEventType.Click)
            tabId = nativeEvent.target.id;
        if (type === TabEventType.First)
            tabId = tabs[0].id;
        else if (type === TabEventType.Last)
            tabId = tabs[tabs.length - 1].id;
        else if (type === TabEventType.Prev) {
            var selectedIndex = tabs.findIndex(function (t) { return t.id === selectedTabId; });
            var newIndex = selectedIndex - 1;
            selectedIndex = newIndex >= 0 ? newIndex : 0;
            tabId = tabs[selectedIndex].id;
        }
        else if (type === TabEventType.Next) {
            var selectedIndex = tabs.findIndex(function (t) { return t.id === selectedTabId; });
            var newIndex = selectedIndex + 1;
            selectedIndex = newIndex < tabs.length ? newIndex : tabs.length - 1;
            tabId = tabs[selectedIndex].id;
        }
        setSelectedTabId("" + tabId);
        return onTabSelect === null || onTabSelect === void 0 ? void 0 : onTabSelect(tabs.findIndex(function (t) { return t.id === tabId; }), nativeEvent);
    };
    var getTabWith = function (title) { return 25 + title.length * 9.71 + 3; };
    var updateDropdown = function (tabs, tabWidths) {
        var moreTabWidth = getTabWith(dropdownText);
        var containerWidth = nav.current.offsetWidth;
        var availableWidth = containerWidth - moreTabWidth;
        var totalTabsWidth = 0;
        var i = 0;
        var hasOverpassed = false;
        for (i; i < tabWidths.length; i++) {
            totalTabsWidth += tabWidths[i];
            if (totalTabsWidth > availableWidth) {
                hasOverpassed = true;
                break;
            }
        }
        if (hasOverpassed) {
            setVisibleTabs(tabs.slice(0, i));
            setDropdownTabs(tabs.slice(i, tabs.length));
        }
        else {
            setVisibleTabs(tabs);
            setDropdownTabs([]);
        }
    };
    var hasAnyDropdownTabSelected = function () {
        return dropdownTabs.length &&
            dropdownTabs.find(function (t) { return t.id === selectedTabId; }) != null;
    };
    return (React.createElement("div", { className: "tabs" + (className ? " " + className : ''), tabIndex: 0 },
        React.createElement("ul", { ref: nav, className: "nav nav-tabs nav-tabs-dnvgl", role: "tablist" }, visibleTabs === null || visibleTabs === void 0 ? void 0 :
            visibleTabs.map(function (tab, index) { return (React.createElement(Tab, __assign({}, tab, { selected: tab.id === selectedTabId, key: tab.id ? tab.id : tab.title, posInSet: index + 1, setSize: tabs.length, onSelectedTabChanged: handleSelectedTabChanged }))); }),
            !!dropdownTabs.length && (React.createElement("li", { className: "nav-item dropdown" },
                React.createElement("div", { ref: parentRef, className: "dropdown b-dropdown " + (isVisible ? 'show ' : '') + "btn-group" },
                    React.createElement("a", { ref: toggleRef, "aria-haspopup": "true", "aria-expanded": isVisible, href: "#", target: "_self", className: "btn dropdown-toggle btn-none nav-link" + (hasAnyDropdownTabSelected() ? ' active' : '') }, dropdownText),
                    React.createElement("ul", { role: "tablist", tabIndex: -1, className: "dropdown-menu dropdown-menu-right" + (isVisible ? ' show' : '') }, !!dropdownTabs.length &&
                        dropdownTabs.map(function (tab, index) { return (React.createElement(Tab, __assign({}, tab, { selected: tab.id === selectedTabId, key: tab.id ? tab.id : tab.title, posInSet: index + 1, setSize: tabs.length, innerClass: "dropdown-item", onSelectedTabChanged: handleSelectedTabChanged }))); })))))),
        React.createElement("div", { key: "tabs-container", className: "tab-content" }, getTabContent())));
};
export default React.memo(Tabs);
